export const DISCRETE_FEATURES = {
	'any-hover': {none: 1, hover: 1},
	'any-pointer': {none: 1, coarse: 1, fine: 1},
	'color-gamut': {srgb: 1, p3: 1, rec2020: 1},
	grid: {0: 1, 1: 1},
	hover: {none: 1, hover: 1},
	'overflow-block': {none: 1, scroll: 1, paged: 1},
	'overflow-inline': {none: 1, scroll: 1},
	pointer: {none: 1, coarse: 1, fine: 1},
	scan: {interlace: 1, progressive: 1},
	update: {none: 1, slow: 1, fast: 1},
	'display-mode': {fullscreen: 1, standalone: 1, 'minimal-ui': 1, browser: 1},
	'dynamic-range': {standard: 1, high: 1},
	'environment-blending': {opaque: 1, additive: 1, subtractive: 1},
	'forced-colors': {none: 1, active: 1},
	'inverted-colors': {none: 1, inverted: 1},
	'nav-controls': {none: 1, back: 1},
	'prefers-color-scheme': {light: 1, dark: 1},
	'prefers-contrast': {'no-preference': 1, less: 1, more: 1, custom: 1},
	'prefers-reduced-data': {'no-preference': 1, reduce: 1},
	'prefers-reduced-motion': {'no-preference': 1, reduce: 1},
	'prefers-reduced-transparency': {'no-preference': 1, reduce: 1},
	scripting: {none: 1, 'initial-only': 1, enabled: 1},
	'video-color-gamut': {srgb: 1, p3: 1, rec2020: 1},
	'video-dynamic-range': {standard: 1, high: 1}
}
export const RANGE_NUMBER_FEATURES = {
	color: {feature: 'color', type: 'integer', bounds: [!0, 0, 1 / 0, !1]},
	'color-index': {feature: 'color-index', type: 'integer', bounds: [!0, 0, 1 / 0, !1]},
	monochrome: {feature: 'monochrome', type: 'integer', bounds: [!0, 0, 1 / 0, !1]},
	'device-height': {feature: 'device-height', type: 'length', bounds: [!0, 0, 1 / 0, !1]},
	'device-width': {feature: 'device-width', type: 'length', bounds: [!0, 0, 1 / 0, !1]},
	height: {feature: 'height', type: 'length', bounds: [!0, 0, 1 / 0, !1]},
	width: {feature: 'width', type: 'length', bounds: [!0, 0, 1 / 0, !1]},
	resolution: {feature: 'resolution', type: 'resolution', bounds: [!0, 0, 1 / 0, !1]},
	'horizontal-viewport-segments': {
		feature: 'horizontal-viewport-segments',
		type: 'integer',
		bounds: [!0, 0, 1 / 0, !1]
	},
	'vertical-viewport-segments': {
		feature: 'vertical-viewport-segments',
		type: 'integer',
		bounds: [!0, 0, 1 / 0, !1]
	}
}
export const RANGE_RATIO_FEATURES = {
	'aspect-ratio': {feature: 'aspect-ratio', type: 'ratio', bounds: [!1, [0, 1], [1 / 0, 1], !1]},
	'device-aspect-ratio': {
		feature: 'device-aspect-ratio',
		type: 'ratio',
		bounds: [!1, [0, 1], [1 / 0, 1], !1]
	}
}
export const permToConditionPairs = e => Object.entries(e).filter(e => void 0 !== e[1])
const e = new Set(Object.keys(DISCRETE_FEATURES))
export const hasDiscreteKey = t => e.has(t[0])
export const isDiscreteKey = t => e.has(t)
const t = new Set(Object.keys(RANGE_RATIO_FEATURES))
export const hasRangeRatioKey = e => t.has(e[0])
export const isRangeRatioKey = e => t.has(e)
const o = new Set(Object.keys(RANGE_NUMBER_FEATURES))
export const hasRangeNumberKey = e => o.has(e[0])
export const isRangeNumberKey = e => o.has(e)
export const hasRangeKey = e => hasRangeNumberKey(e) || hasRangeRatioKey(e)
export const isRangeKey = e => isRangeNumberKey(e) || isRangeRatioKey(e)
const n = new Set([
	'any-hover',
	'any-pointer',
	'color-gamut',
	'grid',
	'hover',
	'overflow-block',
	'overflow-inline',
	'pointer',
	'scan',
	'update',
	'aspect-ratio',
	'color',
	'color-index',
	'device-aspect-ratio',
	'device-height',
	'device-width',
	'height',
	'monochrome',
	'resolution',
	'width',
	'media-type',
	'invalid-features'
])
export const isPermKey = e => n.has(e)
export const isFeatureKey = e => isRangeNumberKey(e) || isRangeRatioKey(e) || isDiscreteKey(e)
export const attachPair = (e, t) => {
	e[t[0]] = t[1]
}
export const andRanges = (...e) =>
	e.reduce(
		(e, t) =>
			'{true}' === e
				? t
				: '{true}' === t
				? e
				: '{false}' === e || '{false}' === t
				? '{false}'
				: ((e, t) => {
						const [o, n, r, s] = e,
							a = 'number' == typeof n ? n : n[0] / n[1],
							i = 'number' == typeof r ? r : r[0] / r[1],
							[c, p, u, d] = t,
							l = 'number' == typeof p ? p : p[0] / p[1],
							g = 'number' == typeof u ? u : u[0] / u[1]
						let f = o !== c && !o
						a !== l && (f = a > l)
						let h = s !== d && !s
						i !== g && (h = i < g)
						const y = f ? o : c,
							R = f ? n : p,
							b = h ? r : u,
							m = h ? s : d
						return R > b || (R === b && (!y || !m)) ? '{false}' : [y, R, b, m]
				  })(e, t),
		'{true}'
	)
export const boundRange = e => {
	if (hasRangeRatioKey(e)) {
		const {bounds: t} = RANGE_RATIO_FEATURES[e[0]],
			o = andRanges(e[1], t)
		if ('string' == typeof o) return o
		if (
			o[0] === t[0] &&
			o[1][0] === t[1][0] &&
			o[1][1] === t[1][1] &&
			o[2][0] === t[2][0] &&
			o[2][1] === t[2][1] &&
			o[3] === t[3]
		)
			return '{true}'
		{
			const e = o[1][0] / o[1][1],
				t = o[2][0] / o[2][1]
			return e > t || (e === t && (!o[0] || !o[3])) ? '{false}' : o
		}
	}
	{
		const {bounds: t} = RANGE_NUMBER_FEATURES[e[0]],
			o = andRanges(e[1], t)
		return 'string' == typeof o
			? o
			: o[0] === t[0] && o[1] === t[1] && o[2] === t[2] && o[3] === t[3]
			? '{true}'
			: o[1] > o[2] || (o[1] === o[2] && (!o[0] || !o[3]))
			? '{false}'
			: o
	}
}
export const binaryOrRanges = (e, t) => {
	const [o, n, r, s] = e,
		a = 'number' == typeof n ? n : n[0] / n[1],
		i = 'number' == typeof r ? r : r[0] / r[1],
		[c, p, u, d] = t,
		l = 'number' == typeof p ? p : p[0] / p[1],
		g = 'number' == typeof u ? u : u[0] / u[1]
	let f = !1
	if (
		((f =
			a < l || (a === l && o) ? l < i || (l === i && (c || s)) : a < g || (a === g && (o || d))),
		f)
	) {
		let e = o || c
		a > l ? (e = c) : a < l && (e = o)
		let t = s || d
		return i > g ? (t = s) : i < g && (t = d), [[e, a < l ? n : p, i < g ? r : u, t]]
	}
	return [e, t]
}
export const notRatioRange = e => {
	if ('string' == typeof e[1]) throw new Error('expected range')
	const {bounds: t} = RANGE_RATIO_FEATURES[e[0]],
		[o, n, r, s] = e[1],
		a = n[0] / n[1],
		i = r[0] / r[1],
		c = t[1][0] / t[1][1],
		p = t[0],
		u = t[2][0] / t[2][1],
		d = t[3],
		l = i > u || (i === u && !(d && !s))
	return a < c || (a === c && !(p && !o))
		? l
			? '{false}'
			: [[!s, r, t[2], t[3]]]
		: l
		? [[t[0], t[1], n, !o]]
		: [
				[t[0], t[1], n, !o],
				[!s, r, t[2], t[3]]
		  ]
}
export function notNumberRange(e) {
	if ('string' == typeof e[1]) throw new Error('expected range')
	const {bounds: t} = RANGE_NUMBER_FEATURES[e[0]],
		[o, n, r, s] = e[1],
		a = t[1],
		i = t[0],
		c = t[2],
		p = t[3],
		u = r > c || (r === c && !(p && !s))
	return n < a || (n === a && !(i && !o))
		? u
			? '{false}'
			: [[!s, r, t[2], t[3]]]
		: u
		? [[t[0], t[1], n, !o]]
		: [
				[t[0], t[1], n, !o],
				[!s, r, t[2], t[3]]
		  ]
}
